module.exports = __webpack_public_path__ + "img/bg_sev_d.830c2430.jpg";